import { apiClient } from "./api.js";

export interface StatsResponse {
  weekly: {
    total: number;
    byAlert: Record<string, number>;
  };
  monthly: {
    total: number;
    byAlert: Record<string, number>;
  };
}

export async function getStats(): Promise<StatsResponse> {
  return apiClient<StatsResponse>("/api/stats");
}
